var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddMfa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 92,
    viewBox: "0 0 50 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8268 0H6.17213C2.77716 0 0 2.77715 0 6.17213V85.0947C0 88.4897 2.77716 91.2668 6.17213 91.2668H43.8268C47.2218 91.2668 50 88.4897 50 85.0947V6.17213C49.999 2.77715 47.2218 0 43.8268 0ZM24.9995 85.9593C22.8769 85.9593 21.1467 84.2281 21.1467 82.1065C21.1467 79.9849 22.8779 78.2538 24.9995 78.2538C27.1211 78.2538 28.8522 79.9849 28.8522 82.1065C28.8522 84.2281 27.1221 85.9593 24.9995 85.9593ZM46.2329 74.3154H3.76608V8.0358H46.2329V74.3154Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMfa);
export default __webpack_public_path__ + "static/media/add_mfa.689179ff553529d5f749b97ec32d308d.svg";
export { ForwardRef as ReactComponent };